<template>
  <div>
    <div
        v-for="item in items"
        :key="item.id"
        class="border-bottom border-right border-left">
      <div class="row">
        <div class="col-2 py-3">
          <div class="pl-4">
            {{formatDate(item.dateFrom, 'd.m.y')}}
            {{item.dateTo instanceof Date ? ` - ${formatDate(item.dateTo, 'd.m.y')}` : ''}}
          </div>
        </div>

        <div class="col-2 py-3 border-left">
          <div class="px-2">
            {{item.typeTitle ? item.typeTitle : '-'}}
          </div>
        </div>

        <div class="col-3 py-3 border-left">
          <div
              class="px-2 cursor-pointer"
              @click="$emit('select', item.id)">
            {{item.diagnosis ? item.diagnosis.title : '-'}}
          </div>
        </div>

        <div class="col-3 py-3 border-left">
          <div class="px-2">
            {{item.note}}
          </div>
        </div>

        <div class="col-2 py-3 border-left">
          <div class="pl-4 text-nowrap">
            {{item.createdBy}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '../../../../utils/formatDate';

export default {
  name: 'ClientConclusionDiagnosesList',

  props: ['items'],

  methods: {
    formatDate(date, format) {
      return formatDate(date, format);
    }
  },
};
</script>
